import React, { useEffect, useState } from "react";
import useParts from "../../hooks/useParts";
import Product from "../Home/Product";
import Loading from "../Shared/Loading";

const Shops = () => {
  const [priceHigh, setPriceHigh] = useState();
  const [carParts, isLoading] = useParts();
  const [searchTerm, setSearchTerm] = useState();
  const [search, setSearch] = useState("");
  const [filteredProducts, setFilteredProducts] = useState([]);
  const newProducts = [...carParts];
  let shopProducts = newProducts.sort();
  const handlePriceLow = () => {
    setPriceHigh(false);
  };
  const handlePriceHigh = () => {
    setPriceHigh(true);
  };

  if (priceHigh === false) {
    shopProducts = newProducts.sort((a, b) => {
      return a.price - b.price;
    });
  }
  if (priceHigh === true) {
    shopProducts = newProducts.sort((a, b) => {
      return b.price - a.price;
    });
  }

  // const category = ["tws", "SmartWatch", "router"]
  const handleSearch = (category) => {
    setSearchTerm(true);
    setSearch(category);
  };

  useEffect(() => {
    if (searchTerm === true) {
      setFilteredProducts(
        shopProducts.filter((product) =>
          product.name.toLowerCase().includes(search.toLowerCase())
        )
      );
    }
  }, [search, searchTerm, shopProducts]);

  if (isLoading) {
    return <Loading></Loading>;
  }
  return (
    <div className="max-w-7xl mx-auto px-1 mb-20">
      <h4 className="md:text-5xl text-3xl font-bold text-center my-4 text-transparent  bg-clip-text bg-gradient-to-r from-accent to-green-400">
        Explore a Universe of Extraordinary Finds!
      </h4>

      <div className="mx-auto text-center mb-5 text-accent">
        <button
          className="btn btn-outline  border-2 my-2 btn-sm capitalize  mr-2  border-white shadow-2xl text-accent bg-gradient-to-r from-secondary to-primary-500 hover:from-green-500 hover:to-blue-500 font-bold"
          onClick={handlePriceLow}
        >
          Low Price
        </button>
        <button
          className="btn btn-outline  border-2 my-2 btn-sm capitalize   border-white shadow-2xl text-accent bg-gradient-to-r from-secondary-400 to-primary-500 hover:from-green-500 hover:to-blue-500 font-bold ml-2"
          onClick={handlePriceHigh}
        >
          {" "}
          High Price
        </button>
        <button
          className="btn btn-outline  border-2 my-2 btn-sm capitalize   border-white shadow-2xl text-accent bg-gradient-to-r from-secondary-400 to-primary-500 hover:from-green-500 hover:to-blue-500 font-bold ml-2"
          onClick={() => handleSearch("tws")}
        >
          {" "}
          tws
        </button>
        <button
          className="btn btn-outline  border-2 my-2 btn-sm capitalize   border-white shadow-2xl text-accent bg-gradient-to-r from-secondary-400 to-primary-500 hover:from-green-500 hover:to-blue-500 font-bold ml-2"
          onClick={() => handleSearch("SmartWatch")}
        >
          {" "}
          Smart Watch
        </button>
        <button
          className="btn btn-outline  border-2 my-2 btn-sm capitalize   border-white shadow-2xl text-accent bg-gradient-to-r from-secondary-400 to-primary-500 hover:from-green-500 hover:to-blue-500 font-bold ml-2"
          onClick={() => handleSearch("router")}
        >
          {" "}
          Router
        </button>
        <button
          className="btn btn-outline  border-2 my-2 btn-sm capitalize   border-white shadow-2xl text-accent bg-gradient-to-r from-secondary-400 to-primary-500 hover:from-green-500 hover:to-blue-500 font-bold ml-2"
          onClick={() => handleSearch("Kettle")}
        >
          {" "}
          Kettle
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 px-5 text-black mb-5">
        {filteredProducts.map((carPart) => (
          <Product key={carPart._id} carPart={carPart}></Product>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 px-5 text-black">
        {shopProducts.map((carPart) => (
          <Product key={carPart._id} carPart={carPart}></Product>
        ))}
      </div>
    </div>
  );
};

export default Shops;
